export const LOADING_COMPLAINTS = "LOADING_COMPLAINTS";
export const GET_COMPLAINTS_LIST = "GET_COMPLAINTS_LIST";
export const REMOVE_COMPLAINTS = "REMOVE_COMPLAINTS";
export const ADD_COMPLAINTS = "ADD_COMPLAINTS";
export const UPDATE_COMPLAINTS = "UPDATE_COMPLAINTS";
export const UPDATE_COMPLAINT_STATUS = "UPDATE_COMPLAINT_STATUS";
export const GET_COMPLAINT_ID = "GET_COMPLAINT_ID";
export const GET_FEEDBACK_ID = "GET_FEEDBACK_ID";
export const REMOVE_FEEDBACK = "REMOVE_FEEDBACK";